import { useContext, useState, useEffect } from 'react';
import PageContext from './PageContext';
import MultipartWorkflowTableRow from './MultipartWorkflowTableRow';
import { HttpContext } from '../../api-services/HttpService';
import Checkbox from '@mui/material/Checkbox';
import FormControlLabel from '@mui/material/FormControlLabel';
import ApiRequestButton from './ApiRequestButton';
import OrderedDataTable from './OrderedDataTableCopy';
import ButtonComponent from "./ButtonComponent";
import CCOffcanvas from "./CCOffcanvas.tsx";
import WarningIcon from '../../svgs/warning-icon.svg';
import BannerAlert from './BannerAlertCopy.jsx';

const MultipartOffcanvas = ({ checkList }) => {
    //get context from parent
    const {
        multipartWorkflowModal,
        setMultipartWorkflowModal,
        workflowButtonCss,
        workflowOptOut,
        multipartWorkflowAction,
        workflowActionCheckedList,
        workflowActionStatus,
        refreshSummaryData,
        snackbarAlert,
    } = useContext(PageContext);
    // initialize http context 
    const {
        POST,
    } = useContext(HttpContext);
    // initialize state
    const [submissionComment, setSubmissionComment] = useState('');
    const [optOut, setOptOut] = useState(false);

    // initialize state for tableHeader
    const [tableHeader, setTableHeader] = useState([
        { columnname: 'mastercompanyname', columntag: 'Company' },
        { columnname: 'status', columntag: 'Status' },
        { columnname: 'rebatecycle', columntag: 'Rebate Cycle' },
        { columnname: 'incentivefreq', columntag: 'Rebate Frequency' },
        { columnname: 'grossspend', columntag: 'Spend Amount' },
        { columnname: 'grossinterchange', columntag: 'Interchange Amount' },
        { columnname: 'incentiveamount', columntag: 'Rebate Amount' },
    ]);

    // create function for workflow action: submit. function takes in a checklist, parses workflowid and calls api 
    const sendWorkflowAction = (buttonaction, action, checklist, comment) => {
        return new Promise((resolve, reject) => {
            let response;
            console.log('/rebate/summary/multicompany/' + buttonaction + '/' + action);
            // check to make sure there is a comment 
            if (comment.length == 0) {
                // show snackar on error
                snackbarAlert(true, 'Please enter a comment', 'error');
                reject();
                return;
            }
            // use POST function to make request
            POST('/rebate/summary/multicompany/' + buttonaction + '/' + action, {
                workflowids: checklist.map(workflow => workflow.workflowid),
                comment: comment,
            }).then(res => {
                console.log(res);
                response = res;
                // hide modal on success
                setMultipartWorkflowModal(multipartWorkflowModal => multipartWorkflowModal = false);
                // default sta value 
                setSubmissionComment(submissionComment => submissionComment = '');
                setOptOut(optOut => optOut = false);
                // show snackbar on success
                snackbarAlert(true, 'Successfully updated workflow.', 'success');
                // refresh data on success
                return refreshSummaryData();
            }).then(res => {
                console.log(res);
                // resolve on success
                resolve(response);
            }).catch(err => {
                console.log(err);
                // show snackar on error
                snackbarAlert(true, 'Error updating workflow.', 'error');
                // reject on error
                reject(err);
            });
        });
    }

    // create function for opting out of workflow . function takes in a checklist, parses workflowid and calls api 
    const sendOptOut = (buttonAction, checklist, comment) => {
        return new Promise((resolve, reject) => {
            let response;
            console.log('opt out');
            // check to make sure there is a comment 
            if (comment.length == 0) {
                // show snackar on error
                snackbarAlert(true, 'Please enter a comment', 'error');
                reject();
                return;
            }
            // use POST function to make request
            POST('/rebate/summary/multicompany/' + buttonAction + '/optout', {
                workflowids: checklist.map(workflow => workflow.workflowid),
                comment: comment,
            }).then(res => {
                console.log(res);
                response = res;
                // hide modal on success
                setMultipartWorkflowModal(multipartWorkflowActionModal => multipartWorkflowActionModal = false);
                // default comment value
                setSubmissionComment(submissionComment => submissionComment = '');
                setOptOut(optOut => optOut = false);
                // show snackbar on success
                snackbarAlert(true, 'Successfully updated workflow.', 'success');
                // refresh data on success
                return refreshSummaryData();
            }).then(res => {
                console.log(res);
                // resolve on success
                resolve(response)
            }).catch(err => {
                console.log(err);
                // show snackar on error
                snackbarAlert(true, 'Error updating workflow.', 'error');
                // reject on error
                reject(err);
            });
        });
    }

    // function wrapper to pass row component to table
    const RowComponent = (row, count, tableHeader,stickyEnabled) => {
        return <>
            <MultipartWorkflowTableRow row={row} count={count} tableHeader={tableHeader} stickyEnabled={stickyEnabled} />
        </>;
    }

    // event handler for action
    const onAction = () => {
        return new Promise((resolve, reject) => {
            //send workflow
            if (optOut) {
                sendOptOut(workflowActionStatus, checkList, submissionComment).then(res => {
                    resolve(res);
                }).catch(err => {
                    reject(err);
                });
            }
            else {
                sendWorkflowAction(workflowActionStatus, multipartWorkflowAction, checkList, submissionComment).then(res => {
                    resolve(res);
                }).catch(err => {
                    reject(err);
                });;
            }
        });
    }
    return (
        <CCOffcanvas
            title={`Multi Company ${multipartWorkflowAction} Rebate Form`}
            show={multipartWorkflowModal}
            onCanvasClose={() => setMultipartWorkflowModal(false)}
            bodyCssClassName="offcanvas-body"
            offCanvasClassName="offcanvas-parent-card"
        >
            <div className="d-flex flex-column h-100">
                <div className="d-flex flex-column flex-grow-1 overflow-scroll">
                    <div className="p-3 trail-section">
                        <div className="bg-white trail-card">
                            <OrderedDataTable RowComponent={RowComponent} tableHeader={tableHeader} dataList={workflowActionCheckedList} numToPage={100} disableMaxTableHeight={true} stickyFirstColumnEnabled={true} />
                        </div>
                    </div>
                    <div className="p-3 comment-section">
                        <div className="bg-white comment-card" >

                            <div className="p-3">
                                {/* input for comment on action */}
                                <div className="offcanvas-details pb-3" style={{ fontSize: '14px' }}>
                                    Comment
                                </div>
                                <input className="w-100 input-text-field" value={submissionComment} onChange={(e) => setSubmissionComment(submissionComment => submissionComment = e.target.value)} placeholder='Type comments here'></input>
                            </div>
                        </div>
                    </div>
                    {workflowOptOut.current ? <div className="p-3 comment-section">
                        <div className="bg-white comment-card" >

                            <div className="p-3">
                                {/* show opt out option when flag is true */}
                                <div style={{ fontSize: '12px' }}>
                                    <FormControlLabel
                                        value="end"
                                        control={<Checkbox
                                            sx={{
                                                // color: '#ff0f0f',
                                                '&.Mui-checked': {
                                                    color: '#ff0f0f',
                                                },
                                            }} />}
                                        onClick={(e) => setOptOut(optOut => optOut = e.target.checked)}
                                        label="Opt out of Rebate Workflow"
                                        labelPlacement="end"
                                    // sx={{
                                    //     color: 'red',
                                    // }}
                                    />
                                </div>
                                {/* show alert for submitting companies without ccrms */}
                                <BannerAlert disableClose show={true} type='info' message={'Companies without a ' + process.env.REACT_APP_CCRM_DESCRIPTION + ' will automatically be opted out of ' + process.env.REACT_APP_CCRM_DESCRIPTION + ' review.'} width='100%' />                  
                            </div>
                        </div>
                    </div> : <></>}
                </div>
                <div
                   className="d-flex justify-content-end p-3 w-100 offcanvas-footer z-2" style={{height: '65px'}}
                >
                    {/* show review submissionComments when flag is true */}
                    {/* <button class={workflowButtonCss.current} onClick={() => onAction()}>{multipartWorkflowAction}</button> */}
                    <ButtonComponent tag={"Cancel"}
                        border={'#fcd800 1px solid'} background={'#fff'} color={'#001317'}
                        onButtonClick={() => { setSubmissionComment(''); setMultipartWorkflowModal(false) }}
                    />
                    <ApiRequestButton onButtonClick={onAction} tag={multipartWorkflowAction} />
                </div>
            </div>                                 
        </CCOffcanvas>
    );
}

export default MultipartOffcanvas; 